import { forwardRef } from 'react';
import type { SVGIconProps } from '../types';
export const OsMacosIcon = forwardRef<SVGSVGElement, SVGIconProps>(({
  color = 'currentColor',
  size = 16,
  ...props
}, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_51_302" style={{
    maskType: 'alpha'
  }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_302)">
        <path d="M13.5856 11.0382C13.2801 11.7146 13.134 12.017 12.7416 12.6147C12.1935 13.4495 11.4195 14.4912 10.4626 14.4984C9.61147 14.5055 9.39179 13.943 8.23669 13.9522C7.08158 13.9579 6.84096 14.5086 5.98881 14.4999C5.03192 14.4912 4.29932 13.5527 3.75063 12.7195C2.21646 10.3822 2.05451 7.64284 3.0027 6.1853C3.67349 5.15178 4.7351 4.54486 5.73183 4.54486C6.74695 4.54486 7.38505 5.10274 8.22443 5.10274C9.03877 5.10274 9.53484 4.54332 10.7088 4.54332C11.5968 4.54332 12.5358 5.02713 13.2065 5.86191C11.0118 7.06452 11.3684 10.1993 13.5856 11.0382ZM9.81787 3.61045C10.245 3.06228 10.5689 2.2888 10.4514 1.5C9.75452 1.54751 8.93966 1.99249 8.46352 2.56876C8.03233 3.09344 7.67472 3.87305 7.81419 4.62711C8.57438 4.65163 9.36114 4.19848 9.81787 3.61045Z" fill={color} />
      </g>
    </svg>);
OsMacosIcon.displayName = 'OsMacosIcon';